import React, {useRef, useState} from 'react'
import Paper from "@material-ui/core/Paper/Paper";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/styles";
import {useCreateUsers} from "../services/user";
import {useHistory} from 'react-router-dom'
export default function NewUserFrom() {

    const createUsers = useCreateUsers();
    const history = useHistory()
    const phoneRef = useRef();
    const nameRef = useRef();
    const emailRef = useRef();
    const passRef = useRef();

    const [error, setError] = useState(false);


    async function handleSubmit() {
        const done = await createUsers(nameRef.current.value, phoneRef.current.value, emailRef.current.value, passRef.current.value);
        if (done) {
            history.push('/users')
        }
        setError(!done)
    }

    const classes = useStyles();

    return (
        <Paper variant="outlined" className={classes.root}>
            <form autoComplete={false}>
                <div className={classes.input}>
                    <TextField label="نام" variant="filled" size="small" fullWidth
                               inputRef={nameRef} error={error}/>
                </div>
                <div className={classes.input}>
                    <TextField label="شماره‌همراه" variant="filled" size="small" type="tel" fullWidth
                               inputRef={phoneRef} error={error}/>
                </div>
                <div className={classes.input}>
                    <TextField label="آدرس ایمیل" variant="filled" size="small" type="email" fullWidth
                               inputRef={emailRef} error={error}/>
                </div>
                <div className={classes.input}>
                    <TextField label="رمز عبور" variant="filled" size="small" type="password" fullWidth
                               inputRef={passRef} error={error}/>
                </div>

                <Button variant="contained" color="primary" className={classes.button}
                        fullWidth onClick={handleSubmit}>ایجاد</Button>
            </form>
        </Paper>
    )
}

const useStyles = makeStyles(theme => ({

    root: {
        textAlign: 'center',
        padding: theme.spacing(5, 5, 3, 5),
        borderColor: theme.palette.primary.main
    },
    input: {
        margin: theme.spacing(2, 0),
    },
    button: {
        marginTop: theme.spacing(4),
        color: 'white'
    },
    text: {
        marginTop: theme.spacing(10)
    }
}));
